<template>
  <div>
    <div class="header-2">
      <div class="page-header header-filter">
        <div 
          :style="{backgroundImage: 'url(' + options.defaultAirport.backgroundImageUrl + ')'}"
          class="page-header-image" 
          style="background-image: url('img/bg-default.png')"/>
        <div class="content-center">
          <div class="container">
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto text-center">
                <h1 class="title">Cancelation Policy</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-12 mt-5">
          <p>All cancellation requests must be made to Airportpc.com, NOT the parking facility.</p>
          <p>All reservation cancellations are subject to a $5.99 Cancellation Fee and 1 Day of parking.</p>
          <p>The Cancellation request must be received 24 hours before the reservation's start date and time.</p>
          <p>Cancellation requests originating after the scheduled service date and time start will NOT be honored.</p>
          <p>Unused parking reservations, whether intentional or not, will NOT be refunded.</p>
          <p>You may cancel your reservation by logging into your account and clicking the cancel icon to the right of the reservation.</p>
          <p>If you're trying to cancel the reservation the same day it was made, you must call us at <a href="tel:888-349-1402">(888) 349-1402</a> or email us at <a href = "mailto:info@airportpc.com">info@airportpc.com</a>. You will receive an email confirmation of your cancellation within 1-2 business days.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    data() {
      return {
      };
    },
    computed: {
      ...mapState([
        'options'
      ])
    },
    created() {
      this.setLoading(false);
    },
    methods: {
      ...mapMutations([
        'setLoading'
      ])
    }
  }
</script>
<style lang='scss' scoped>
  .page-header {
    min-height: 25vh !important;

    .page-header-image {
      background-position: center center !important;
    }

    .container {
      text-align: left !important;

      .title {
        @media (max-width: 771px) {
          font-size: 2.25em;
        }
      }
    }
  }
</style>
